export const RightChevron = ({ disabled = true }: { disabled?: boolean }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="24px chevron">
      <path
        id="Vector"
        d="M9 18L15 12L9 6"
        stroke={disabled ? "#E8F6FC" : "#1B51DC"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
